//Seeting the variavles to apply dinamicaly on the charts
export const Colors = {
    // PRIMARY
    'green-deloitte': '#86BC25',
    'green-4': '#43B02A',
    'green-aa': '#26890D',
    'black-1': '#000000',
    'teal-aa': '#0D8390',
    'blue-aa': '#007CB0',
    // SECONDARY
    'green-7': '#2C5234',
    'green-5': '#009A44',
    'green-2': '#C4D600',
    'green-1': '#E3E48D',
    'blue-7': '#041E42',
    'blue-6': '#012169',
    'blue-5': '#005587',
    'blue-4': '#0076A8',
    'blue-3': '#00A3E0',
    'blue-2': '#62B5E5',
    'blue-1': '#A0DCFF',
    'teal-7': '#004F59',
    'teal-6': '#007680',
    'teal-5': '#0097A9',
    'teal-4': '#00ABAB',
    'teal-3': '#6FC2B4',
    'teal-2': '#9DD4CF',
    'teal-1': '#DDEFE8',
    'coolgray-12': '#222222',
    'coolgray-11': '#53565A',
    'coolgray-10': '#63666A',
    'coolgray-9': '#75787B',
    'coolgray-7': '#97999B',
    'coolgray-6': '#A7A8AA',
    'coolgray-4': '#BBBCBC',
    'coolgray-2': '#D0D0CE',
    // BRIGHT
    'bright-green': '#0DF200',
    'brigh-tteal': '#3EFAC5',
    'bright-blue': '#33F0FF',
    // NEUTRAL
    'neutral-3': '#DCE3E5',
    'neutral-2': '#E6EDF0',
    'neutral-1': '#F2F6F7',
    'neutral-0.5': '#F5F8FA',
    'white': '#FFFFFF',
    // SEMANTIC
    'information-6': '#174291',
    'information-5': '#1D53B7',
    'information-4': '#276EF1',
    'information-3': '#5A90F4',
    'information-2': '#9FBFF8',
    'information-1': '#D4E2FC',
    'success-6': '#156A36',
    'success-5': '#09863D',
    'success-4': '#21A453',
    'success-3': '#43BF75',
    'success-2': '#9EE2B8',
    'success-1': '#CFF3DD',
    'error-6': '#7F281E',
    'error-5': '#A13226',
    'error-4': '#D44333',
    'error-3': '#DE7063',
    'error-2': '#ECACA5',
    'error-1': '#F6D9D6',
    'warning-6': '#916821',
    'warning-5': '#C19132',
    'warning-4': '#FFC043',
    'warning-3': '#FFCF70',
    'warning-2': '#FFE3AC',
    'warning-1': '#FFF2D9',

    //PRIORITY
    'critical-dark': '#540000',
    'critical-base': '#E82020',
    'critical-light': '#FECECE',
    'high-dark': '#4D1A00',
    'high-base': '#EE722E',
    'high-light': '#FFE2D1',
    'medium-dark': '#4D4D00',
    'medium-base': '#FADA33',
    'medium-light': '#FFF6A5',
    'low-dark': '#004D10',
    'low-base': '#5BDA77',
    'low-light': 'rgba(202, 248, 212, 1)',
    'info-dark': '#13384D',
    'info-base': '#62B5F4',
    'info-light': "#A2DCFF",

    //Charts
    //Dark
    'chart-dark-1': '#004541',
    'chart-dark-2': '#000373',
    'chart-dark-3': '#591717',
    'chart-dark-4': '#590026',
    'chart-dark-5': '#004900',
    'chart-dark-6': '#460000',
    'chart-dark-7': '#2A0066',
    'chart-dark-8': '#4D0000',
    'chart-dark-9': '#001A4D',
    'chart-dark-10': '#4D1800',
    'chart-dark-11': '#362E04',
    'chart-dark-12': '#004022',
    'chart-dark-13': '#283C00',
    'chart-dark-14': '##1A1D59',

    //Base
    'chart-base-1': '#0C9D97',
    'chart-base-2': '#4046CA',
    'chart-base-3': '#DE7676',
    'chart-base-4': '#DC2F79',
    'chart-base-5': '#0BA300',
    'chart-base-6': '#A22B11',
    'chart-base-7': '#7326D3',
    'chart-base-8': '#E34545',
    'chart-base-9': '#0360CD',
    'chart-base-10': '#BE5802',
    'chart-base-11': '#A69542',
    'chart-base-12': '#008F5D',
    'chart-base-13': '#79A100',
    'chart-base-14': '#8286F1',

    //Medium
    'chart-medium-1': '#66CDC9',
    'chart-medium-2': '#8488E8',
    'chart-medium-3': '#F1A7A7',
    'chart-medium-4': '#F478AD',
    'chart-medium-5': '#66D266',
    'chart-medium-6': '#D07A68',
    'chart-medium-7': '#AA72EF',
    'chart-medium-8': '#F88686',
    'chart-medium-9': '#669FED',
    'chart-medium-10': '#E39A66',
    'chart-medium-11': '#D0C388',
    'chart-medium-12': '#66C4A0',
    'chart-medium-13': '#B4D066',
    'chart-medium-14': '#ADB0FD',

    // Light
    'chart-light-1': '#CCEEED',
    'chart-light-2': '#D6D8F7',
    'chart-light-3': '#FBE2E2',
    'chart-light-4': '#FCD2E4',
    'chart-light-5': '#CCF0CC',
    'chart-light-6': '#EFD3CD',
    'chart-light-7': '#E3D0FA',
    'chart-light-8': '#FDD7D7',
    'chart-light-9': '#CCDFF9',
    'chart-light-10': '#F6DDCC',
    'chart-light-11': '#E7E1C3',
    'chart-light-12': '#CCECE0',
    'chart-light-13': '#E6EFCC',
    'chart-light-14': '#E4E5FE',

    //3D Legend
    '75to100': '#007CB0',
    '50to75': '#39ADE5',
    '25to50': '#77CAF2',
    '0to25': '#B9E5FB',
    'full-room': '#DE7063',
    'empty-room': '#43BF75',

    //Temperature 
    '>24': '#EE722E',
    '22to23': '#FADA33',
    '19to21': '#0BA300',
    '<18': '#0360CD',

    //Palette
    'palette-1': '#0C9D97',
    'palette-2': '#4046CA',
    'palette-3': '#F68511',
    'palette-4': '#DE3D82',
    'palette-5': '#7E84FA',
    'palette-6': '#72E06A',
    'palette-7': '#147AF3',
    'palette-8': '#7326D3',
    'palette-9': '#E8C600',
    'palette-10': '#CB5D00',
    'palette-11': '#008F5D',

    //Metricas
    'occupation': '#77caf2',
    'occupation-free': '#b3e1f7',
    'temperature-real': '#ad8093',
    'temperature-estimated': '#ff8fbf',
    'water': '#8286f1',
    'co2': '#ee722e',
    'ligthning': '#0C9D97',
    'parking-occupation': '#e3e3e3',
    'parking-capacity': '#b37f7f',
    "humidity": "#7326D3",
    "sound-level": "#0360CD",

    //IOC
    "red": "#E82020",
    "orange": "#EE722E",
    "yellow": "#FADA33",
    "log-item": "#3878C7"
};

export const chartMediumColors = Object.keys(Colors).filter(colorName => colorName.includes('chart-medium'))?.map(colorName => Colors[colorName]);
